// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-Sfr","label":"styles_label__3buEX"};